import * as angular from "angular";

import {newsfeedsDataTableConfig} from './newsfeed-data-table/newsfeed-data-table.component';
import {newsfeedsConfig} from './newsfeeds.component';
import NewsfeedsService from './newsfeeds-state.service';
import OutputConfig from '../../config/config';
import {newsfeedShowLinksDialog} from './newsfeed-show-links-dialog/newsfeed-show-links-dialog.component';

export default angular
    .module('mw.newsfeeds', [
            'MW.OutputMgr.OutputMgrService',
            'MW.Framework.TextFilters',
            'MW.Framework.CoreUserService',
            'MW.Framework.AnalyticsService',
            'MW.Framework.AppBarTitleService'
        ]
    )
    .component(newsfeedsDataTableConfig.selector, newsfeedsDataTableConfig)
    .service('NewsfeedsService', NewsfeedsService)
    .service('OutputConfig', OutputConfig)
    .component(newsfeedsConfig.selector, newsfeedsConfig)
    .component(newsfeedShowLinksDialog.selector, newsfeedShowLinksDialog)
    .name;



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/app/newsfeeds/newsfeeds.module.ts
 **/